import React from "react";
import "./IntroStatusLine.scss";

const TONE = {
  accepted: "positive",
  not_a_fit: "neutral",
  delivered: "quiet",
  opened: "active",
  waiting: "quiet",
  reviewing: "quiet",
  search_may_have_paused: "quiet",
  search_found_home: "neutral",
  search_ended: "neutral",
  withdrawn: "neutral",
};

const PARTS = [
  ["accepted", "accepted"],
  ["not_a_fit", "not a fit"],
  ["opened", "opened"],
  ["delivered", "delivered"],
  ["waiting", "waiting"],
  ["reviewing", "paused"],
  ["search_found_home", "closed"],
  ["search_ended", "withdrawn"],
  ["search_may_have_paused", "withdrawn"],
  ["withdrawn", "withdrawn"],
];

export const summarizeSent = (summary) => {
  if (!summary || !summary.total) return null;
  const counts = summary.counts || {};
  const byLabel = new Map();
  PARTS.forEach(([key, label]) => {
    if (counts[key]) byLabel.set(label, (byLabel.get(label) || 0) + counts[key]);
  });
  const parts = [...byLabel]
    .slice(0, 3)
    .map(([label, count]) => `${count} ${label}`);
  return `${summary.total} sent: ${parts.join(", ")}`;
};

const IntroStatusLine = ({ status }) => {
  if (!status) return null;
  return (
    <p className={`intro-status intro-status--${TONE[status.key] || "quiet"}`}>
      <span className="intro-status__dot" aria-hidden="true" />
      {status.label}
    </p>
  );
};

export const IntroSentSummary = ({ summary }) => {
  const text = summarizeSent(summary);
  return (
    <p className={`intro-status${text ? "" : " intro-status--none"}`}>
      {text || "--"}
    </p>
  );
};

export default IntroStatusLine;
